import { afterAll, afterEach, beforeAll, describe, expect, it } from '@jest/globals';
import { createTempDir, removeTempDir } from '@ms-cloudpack/test-utilities';
import fs from 'fs';
import { getUserPreferencesPath, setMockUserPreferencesDir } from './getUserPreferencesPath.js';
import { writeJsonSync } from '@ms-cloudpack/json-utilities';
import { readUserPreferences } from './readUserPreferences.js';

describe('readUserPreferences', () => {
  let mockUserPreferencesDir: string;
  let mockUserPreferencesPath: string;

  beforeAll(() => {
    mockUserPreferencesDir = createTempDir();
    setMockUserPreferencesDir(mockUserPreferencesDir);
    mockUserPreferencesPath = getUserPreferencesPath();
  });

  afterEach(() => {
    // Delete any preferences after each run
    fs.rmSync(mockUserPreferencesPath, { force: true });
  });

  afterAll(async () => {
    await removeTempDir(mockUserPreferencesDir);
  });

  it("returns an empty object if the file doesn't exist", async () => {
    expect(await readUserPreferences()).toEqual({});
  });

  // This is important because the keys of the user preferences will be printed verbatim
  // by `cloudpack config list`
  it('returns contents without the schema', async () => {
    // these don't need to be valid contents
    writeJsonSync(mockUserPreferencesPath, { $schema: 'schema', cachePath: 'cache' });
    expect(await readUserPreferences()).toEqual({ cachePath: 'cache' });
  });
});
